import toggleNav from "./legacy/toggleNav";
import purchaseForm from "./legacy/purchase-form";
import core from "./legacy/core";


toggleNav();
purchaseForm.init();
core.init();
